/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AgentUserSalesNote from './AgentUserSalesNote';
import AgentV1SalesNotesUsersUserIdPatchRequestAllOf from './AgentV1SalesNotesUsersUserIdPatchRequestAllOf';
import SalesNoteCompleteReasonEnum from './SalesNoteCompleteReasonEnum';
import SalesNoteProspectLankEnum from './SalesNoteProspectLankEnum';
import SalesNoteStatusEnum from './SalesNoteStatusEnum';

/**
 * The AgentV1SalesNotesUsersUserIdPatchRequest model module.
 * @module model/AgentV1SalesNotesUsersUserIdPatchRequest
 * @version 1.0.0
 */
class AgentV1SalesNotesUsersUserIdPatchRequest {
    /**
     * Constructs a new <code>AgentV1SalesNotesUsersUserIdPatchRequest</code>.
     * @alias module:model/AgentV1SalesNotesUsersUserIdPatchRequest
     * @implements module:model/AgentUserSalesNote
     * @implements module:model/AgentV1SalesNotesUsersUserIdPatchRequestAllOf
     */
    constructor() { 
        AgentUserSalesNote.initialize(this);AgentV1SalesNotesUsersUserIdPatchRequestAllOf.initialize(this);
        AgentV1SalesNotesUsersUserIdPatchRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AgentV1SalesNotesUsersUserIdPatchRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentV1SalesNotesUsersUserIdPatchRequest} obj Optional instance to populate.
     * @return {module:model/AgentV1SalesNotesUsersUserIdPatchRequest} The populated <code>AgentV1SalesNotesUsersUserIdPatchRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentV1SalesNotesUsersUserIdPatchRequest();
            AgentUserSalesNote.constructFromObject(data, obj);
            AgentV1SalesNotesUsersUserIdPatchRequestAllOf.constructFromObject(data, obj);

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('agent_id')) {
                obj['agent_id'] = ApiClient.convertToType(data['agent_id'], 'Number');
            }
            if (data.hasOwnProperty('user_id')) {
                obj['user_id'] = ApiClient.convertToType(data['user_id'], 'Number');
            }
            if (data.hasOwnProperty('prospect_lank')) {
                obj['prospect_lank'] = SalesNoteProspectLankEnum.constructFromObject(data['prospect_lank']);
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = SalesNoteStatusEnum.constructFromObject(data['status']);
            }
            if (data.hasOwnProperty('complete_reason')) {
                obj['complete_reason'] = SalesNoteCompleteReasonEnum.constructFromObject(data['complete_reason']);
            }
            if (data.hasOwnProperty('progress')) {
                obj['progress'] = ApiClient.convertToType(data['progress'], 'String');
            }
            if (data.hasOwnProperty('appointment_date')) {
                obj['appointment_date'] = ApiClient.convertToType(data['appointment_date'], 'Date');
            }
            if (data.hasOwnProperty('has_action')) {
                obj['has_action'] = ApiClient.convertToType(data['has_action'], 'Boolean');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'Date');
            }
            if (data.hasOwnProperty('last_sales_note_updated_at')) {
                obj['last_sales_note_updated_at'] = ApiClient.convertToType(data['last_sales_note_updated_at'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentV1SalesNotesUsersUserIdPatchRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentV1SalesNotesUsersUserIdPatchRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['progress'] && !(typeof data['progress'] === 'string' || data['progress'] instanceof String)) {
            throw new Error("Expected the field `progress` to be a primitive type in the JSON string but got " + data['progress']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
AgentV1SalesNotesUsersUserIdPatchRequest.prototype['id'] = undefined;

/**
 * @member {Number} agent_id
 */
AgentV1SalesNotesUsersUserIdPatchRequest.prototype['agent_id'] = undefined;

/**
 * @member {Number} user_id
 */
AgentV1SalesNotesUsersUserIdPatchRequest.prototype['user_id'] = undefined;

/**
 * @member {module:model/SalesNoteProspectLankEnum} prospect_lank
 */
AgentV1SalesNotesUsersUserIdPatchRequest.prototype['prospect_lank'] = undefined;

/**
 * @member {module:model/SalesNoteStatusEnum} status
 */
AgentV1SalesNotesUsersUserIdPatchRequest.prototype['status'] = undefined;

/**
 * @member {module:model/SalesNoteCompleteReasonEnum} complete_reason
 */
AgentV1SalesNotesUsersUserIdPatchRequest.prototype['complete_reason'] = undefined;

/**
 * @member {String} progress
 */
AgentV1SalesNotesUsersUserIdPatchRequest.prototype['progress'] = undefined;

/**
 * アポ取得ボタンで登録した最新のアポ日。進捗メモ本文を編集・削除しても保持する
 * @member {Date} appointment_date
 */
AgentV1SalesNotesUsersUserIdPatchRequest.prototype['appointment_date'] = undefined;

/**
 * アクション（架電・不通・メール・SMS）を1回以上実施済みかどうか
 * @member {Boolean} has_action
 */
AgentV1SalesNotesUsersUserIdPatchRequest.prototype['has_action'] = undefined;

/**
 * @member {Date} created_at
 */
AgentV1SalesNotesUsersUserIdPatchRequest.prototype['created_at'] = undefined;

/**
 * @member {Date} updated_at
 */
AgentV1SalesNotesUsersUserIdPatchRequest.prototype['updated_at'] = undefined;

/**
 * 楽観的排他制御用。クライアントが保持している最終更新日時。DBの値と一致しない場合は409を返す。
 * @member {Date} last_sales_note_updated_at
 */
AgentV1SalesNotesUsersUserIdPatchRequest.prototype['last_sales_note_updated_at'] = undefined;


// Implement AgentUserSalesNote interface:
/**
 * @member {Number} id
 */
AgentUserSalesNote.prototype['id'] = undefined;
/**
 * @member {Number} agent_id
 */
AgentUserSalesNote.prototype['agent_id'] = undefined;
/**
 * @member {Number} user_id
 */
AgentUserSalesNote.prototype['user_id'] = undefined;
/**
 * @member {module:model/SalesNoteProspectLankEnum} prospect_lank
 */
AgentUserSalesNote.prototype['prospect_lank'] = undefined;
/**
 * @member {module:model/SalesNoteStatusEnum} status
 */
AgentUserSalesNote.prototype['status'] = undefined;
/**
 * @member {module:model/SalesNoteCompleteReasonEnum} complete_reason
 */
AgentUserSalesNote.prototype['complete_reason'] = undefined;
/**
 * @member {String} progress
 */
AgentUserSalesNote.prototype['progress'] = undefined;
/**
 * アポ取得ボタンで登録した最新のアポ日。進捗メモ本文を編集・削除しても保持する
 * @member {Date} appointment_date
 */
AgentUserSalesNote.prototype['appointment_date'] = undefined;
/**
 * アクション（架電・不通・メール・SMS）を1回以上実施済みかどうか
 * @member {Boolean} has_action
 */
AgentUserSalesNote.prototype['has_action'] = undefined;
/**
 * @member {Date} created_at
 */
AgentUserSalesNote.prototype['created_at'] = undefined;
/**
 * @member {Date} updated_at
 */
AgentUserSalesNote.prototype['updated_at'] = undefined;
// Implement AgentV1SalesNotesUsersUserIdPatchRequestAllOf interface:
/**
 * 楽観的排他制御用。クライアントが保持している最終更新日時。DBの値と一致しない場合は409を返す。
 * @member {Date} last_sales_note_updated_at
 */
AgentV1SalesNotesUsersUserIdPatchRequestAllOf.prototype['last_sales_note_updated_at'] = undefined;




export default AgentV1SalesNotesUsersUserIdPatchRequest;

